export default __webpack_public_path__ + "static/media/3.2a52ca89.png";